import React, { useEffect, useState } from "react";
import TableHeading from "../../components/common/TableHeading";
import { RIGHTARROW_ICON } from "../../../utills/image-constant";
import Inputwithlable from "../../components/common/inputwithlable";
import DropDownWithLabel from "../../components/common/DropDownWithlable";
import {
  addEmployee,
  getAllCompanies,
} from "../../../services/api-services";
import { toastEmitter } from "../../../utills/utilities";
import { API_RESPONSE } from "../../../utills/app-constant";
import { handleFormInput } from "../../../utills/formutilities";
import Loginbtn from "../../components/common/loginbtn";
import { useLocation, useNavigate } from "react-router-dom";
import { ROUTES } from "../../routes/url-constant";
import {
  checkValidation,
  ErrorMessage,
  ErrorMsg,
} from "../../../utills/error-message-constant";
import {
  alphaletter,
  emailRegex,
  NumberRegex,
} from "../../../utills/form-regex";
import PhoneInput from "react-phone-input-2";
import moment from "moment";

const AddOnsiteManagement = () => {
  const location = useLocation();
  const navigate = useNavigate();
  let Employeetype = location?.state?.pageType;
  const [Employeebtndisable, setEmployeebtndisable] = useState(false);
  const [formError, setFormError] = useState();
  const [pending, setPending] = useState(false);
  const [EmployeebtnLoader, setEmployeebtnLoader] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [employeeData, setEmployeeData] = useState({
    id: "",
    employeeName: "",
    email: "",
    mobileNumber: "",
    department: "",
    companyId: "",
    modelId: "",
    modelName: "",
    assessmentFrom: "",
    assessmentTo: "",
    hierarchy: "",
    type: "Offline",
  });

  useEffect(() => {
    if (location?.state?.Data) {
      const data = location.state?.Data;

      setEmployeeData({
        ...data,
        assessmentFrom: moment(data.assessmentFrom).format("YYYY-MM-DD"),
        assessmentTo: moment(data.assessmentTo).format("YYYY-MM-DD"),
      });
    }
  }, [location.state]);

  const getallCompany = async () => {
    setPending(true);
    try {
      const response = await getAllCompanies();
      if (response?.data?.responseCode === 404) {
        companyList([]);
      } else if (response?.data?.responseCode === 200) {
        const companyOptions = response?.data?.responseBody?.map((data) => ({
          value: data?.id,
          label: data?.companyName,
          modelName: data?.modelResponse?.modelName,
          modelId: data?.modelId,
          Status: data?.status,
        }));
        setCompanyList(companyOptions);
      } else {
        toastEmitter("error", response?.data?.message);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setPending(false);
    }
  };

  useEffect(() => {
    getallCompany();
  }, []);

  const handleSelect = (event) => {
    const { name, value } = event.target;

    if (name === "department") {
      setEmployeeData({
        ...employeeData,
        department: value, // Update department value in state
      });
    } else if (name === "hierarchy") {
      setEmployeeData({
        ...employeeData,
        hierarchy: value, // Update hierarchy value in state
      });
    } else if (name === "companyId") {
      const selectedCompany = companyList.find(
        (company) => company.value === value
      );
      setEmployeeData({
        ...employeeData,
        companyId: value,
        modelId: selectedCompany ? selectedCompany.modelId : "",
        modelName: selectedCompany ? selectedCompany.modelName : "",
      });
    }
  };

  const handleAddEmployee = async () => {
    if (Employeetype === "Edit") {
      if (
        !employeeData?.email ||
        !employeeData?.companyId ||
        !employeeData?.department ||
        !employeeData?.hierarchy ||
        !employeeData?.mobileNumber ||
        !employeeData?.employeeName ||
        !employeeData?.modelName ||
        !employeeData?.assessmentFrom ||
        !employeeData?.assessmentTo
      ) {
        toastEmitter("error", "All Fields Required");
        return;
      }
    } else {
      if (
        !employeeData?.email ||
        !employeeData?.companyId ||
        !employeeData?.department ||
        !employeeData?.hierarchy ||
        !employeeData?.mobileNumber ||
        !employeeData?.employeeName ||
        !employeeData?.modelName ||
        !employeeData?.assessmentFrom ||
        !employeeData?.assessmentTo
      ) {
        toastEmitter("error", "All Fields Required");
        return; // Stop execution if any field is empty
      }
    }
    if (
      formError?.nameStatus ||
      formError?.emailStatus ||
      formError?.passwordStatus
    ) {
      toastEmitter("error", "Please fill Vaild Data");
      return; // Stop execution if any field is empty
    }
    setEmployeebtnLoader(true);

    try {
      const response = await addEmployee(employeeData);
      if (response?.data?.responseCode !== 200) {
        toastEmitter("error", response?.data?.message);
      }
      if (response.data?.responseCode === 200) {
        toastEmitter("success", response?.data?.message);
        navigate(ROUTES.ONSITE);
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE.MESSAGE_503);
    } finally {
      setEmployeebtnLoader(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "employeeName") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Name,
        alphaletter,
        formError,
        setFormError
      );
    }

    if (name === "email") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Email,
        emailRegex,
        formError,
        setFormError
      );
    }
    if (name === "mobileNumber") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.MobileNumber,
        NumberRegex,
        formError,
        setFormError
      );
    }
    if (name === "department") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Department,
        alphaletter,
        formError,
        setFormError
      );
    }
    if (name === "hierarchy") {
      checkValidation(
        value,
        name,
        ErrorMessage?.Valid?.Department,
        alphaletter,
        formError,
        setFormError
      );
    }
    if (name === "assessmentFrom" || name === "assessmentTo") {
      const fromDate = employeeData.assessmentFrom;
      const toDate = employeeData.assessmentTo;
      if (name === "assessmentFrom") {
        if (toDate && moment(value)?.isAfter(toDate)) {
          setFormError({
            ...formError,
            assessmentFrom: "Duration From cannot be later than Duration To.",
          });
          setEmployeeData({ ...employeeData, durationFrom: "" });
          return;
        } else if (moment(value)?.isBefore(today)) {
          setFormError({
            ...formError,
            assessmentFrom: "Duration From cannot be a past date.",
          });
          setEmployeeData({ ...employeeData, assessmentFrom: "" });
          return;
        } else {
          setFormError({ ...formError, assessmentFrom: "" });
        }
      }
      if (name === "assessmentTo") {
        if (fromDate && moment(value).isBefore(fromDate)) {
          setFormError({
            ...formError,
            assessmentTo: "Duration To cannot be earlier than Duration From.",
          });
          setEmployeeData({ ...employeeData, assessmentTo: "" });
          return;
        } else {
          setFormError({ ...formError, assessmentTo: "" });
        }
      }
    }
    if (name === "companyId") {
      if (!value) {
        setFormError((prev) => ({
          ...prev,
          companyId: ErrorMessage?.Valid?.Required,
        }));
      } else {
        setFormError((prev) => ({
          ...prev,
          companyId: "",
        }));
      }
    }
    if (name === "modelId") {
      if (!value) {
        setFormError((prev) => ({
          ...prev,
          modelId: ErrorMessage?.Valid?.Required,
        }));
      } else {
        setFormError((prev) => ({
          ...prev,
          modelId: "",
        }));
      }
    }
    setEmployeeData(handleFormInput(e, employeeData));
  };

  const [isNumber, setIsNumber] = useState("us");
  const handleNumber = (e) => {
    setIsNumber(e);
    setEmployeeData({ ...employeeData, mobileNumber: e });
  };
  const handleNavigateBack = () => {
    navigate(ROUTES.COMPANYEMPLOYEEMANAGEMENT);
  };
  const departmentOptions = [
    {
      id: 1,
      value: "executive_strategy",
      label: "Executive and Strategy",
      Status: 1,
    },
    { id: 2, value: "operations", label: "Operations", Status: 1 },
    {
      id: 3,
      value: "technology_it_innovation",
      label: "Technology, IT, and Innovation",
      Status: 1,
    },
    { id: 4, value: "sales_marketing", label: "Sales and Mktg", Status: 1 },
    { id: 5, value: "hr_finance", label: "HR Finance", Status: 1 },
    {
      id: 6,
      value: "legal_regulatory",
      label: "Legal and Regulatory",
      Status: 1,
    },
    { id: 7, value: "supplychain", label: "Supplychain", Status: 1 },
    { id: 8, value: "customer_support", label: "Customer support", Status: 1 },
  ];

  const hierarchyOptions = [
    { id: 1, value: "c_suite", label: "C-suite", Status: 1 },
    { id: 2, value: "executives", label: "Executives", Status: 1 },
    { id: 3, value: "directors", label: "Directors", Status: 1 },
    { id: 4, value: "managers", label: "Managers", Status: 1 },
    { id: 5, value: "supervisor", label: "Supervisor", Status: 1 },
    { id: 6, value: "agents", label: "Agents", Status: 1 },
  ];

  const today = new Date().toISOString().split("T")[0];

  return (
    <>
      <TableHeading
        className="cursor-pointer"
        firstData="Employee Management"
        icon={RIGHTARROW_ICON}
        secondData="Add Employee"
        onFirstDataClick={handleNavigateBack}
      />
      <div className="container-fluid ">
        <div className="caspera_employee_add">
          <div className="row">
            <div className="col-md-12">
              <Inputwithlable
                disable={Employeetype === "view"}
                placeHolder="Enter Employee Name"
                name="employeeName"
                type="text"
                labelName="Enter Name"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                error={formError?.employeeName}
                value={employeeData.employeeName}
              />
              <ErrorMsg error={formError?.employeeName} />
            </div>
            <div className="col-md-6">
              <DropDownWithLabel
                disable={Employeetype === "view"}
                labelName="Select Comapny"
                lableclassName="addInput-label"
                name="companyId"
                options={companyList}
                className="form-control addInputText-lable"
                handleSelect={handleSelect}
                value={employeeData?.companyId}
              />
            </div>
            <div className="col-md-6">
              <Inputwithlable
                disable={Employeetype === "view"}
                placeHolder="Telecom"
                name="modelId"
                type="text"
                labelName="Maturity Model"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={employeeData?.modelName}
              />
              <ErrorMsg error={formError?.modelName} />
            </div>

            <div className="col-md-6">
              <Inputwithlable
                disable={Employeetype === "view"}
                placeHolder="Enter Email"
                name="email"
                type="text"
                labelName="Enter Email"
                lableclassName="addInput-label"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={employeeData?.email}
              />
              <ErrorMsg error={formError?.email} />
            </div>

            <div className="col-md-6 phoneinputdiv">
              <label htmlFor="inputState" className="form-label input-lable">
                Enter Mobile Number <span className="text-danger">*</span>
              </label>

              <PhoneInput
                country={isNumber}
                enableAreaCodes={true}
                value={employeeData.mobileNumber}
                onChange={handleNumber}
                className="addInputText-lable"
              />
              <ErrorMsg error={formError?.mobileNumber} />
            </div>

            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Department"
                name="department"
                options={departmentOptions}
                className="form-control addInputText-lable"
                handleSelect={handleSelect}
                lableclassName="addInput-label"
                value={employeeData?.department}
              />
              <ErrorMsg error={formError?.department} />
            </div>
            <div className="col-md-6">
              <DropDownWithLabel
                labelName="Select Hierarchy"
                name="hierarchy"
                options={hierarchyOptions} // Static hierarchy options
                lableclassName="addInput-label"
                value={employeeData.hierarchy}
                handleSelect={handleSelect}
                className="addInputText-lable"
              />
              <ErrorMsg error={formError?.Hierarchy} />
            </div>
            <div className="col-md-6 calander_data">
              <Inputwithlable
                disable={Employeetype === "view"}
                labelName="Flash Assessment From"
                lableclassName="addInput-label"
                name="assessmentFrom"
                type="date"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={employeeData?.assessmentFrom || ""}
                max={today}
              />
              <ErrorMsg error={formError?.assessmentFrom} />
            </div>
            <div className="col-md-6 calander_data">
              <Inputwithlable
                disable={Employeetype === "view"}
                labelName="Flash Assessment To"
                lableclassName="addInput-label"
                name="assessmentTo"
                type="date"
                className="form-control addInputText-lable"
                handleChange={handleChange}
                value={employeeData?.assessmentTo || ""}
                max={today}
              />
              <ErrorMsg error={formError?.assessmentTo} />
            </div>
          </div>
          <div className="pt-4 d-flex justify-content-center">
            <Loginbtn
              className="submitbtn px-5"
              handleClick={handleAddEmployee}
              type="submit"
              btnName={Employeetype == "Edit" ? "Edit" : "ADD"}
              disablebtn={Employeebtndisable}
              loader={EmployeebtnLoader}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AddOnsiteManagement 
